import { render, staticRenderFns } from "./MemberCenter.vue?vue&type=template&id=05234466&scoped=true"
import script from "./MemberCenter.vue?vue&type=script&lang=js"
export * from "./MemberCenter.vue?vue&type=script&lang=js"
import style0 from "./MemberCenter.vue?vue&type=style&index=0&id=05234466&prod&lang=scss&scoped=true"
import style1 from "./MemberCenter.vue?vue&type=style&index=1&id=05234466&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_7d198ec714527f3eb87755d9f59e0144/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05234466",
  null
  
)

export default component.exports